import React, { Fragment, useContext, useState } from 'react'
import { Form } from 'react-bootstrap';
import ProfileIcon from '../../../assets/icons/TwoFactorIcon.png';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../../auth/AuthContext';
import UserService from '../../../services/UserService';
import AlertService from '../../../services/AlertService';
import { Skeleton } from 'primereact/skeleton';

const VerifyOtp = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const [otp, setOtp] = useState(Array(8).fill(''));
  const [loading, setLoading] = useState(false);

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^[a-zA-Z0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 7) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };
  const handleOtpKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (otp[index] === '') {
        if (index > 0) document.getElementById(`otp-${index - 1}`).focus();
      }
    } else if (e.key === 'ArrowLeft' && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    } else if (e.key === 'ArrowRight' && index < 7) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };
  const handlePaste = (e, startIndex) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text');
    const cleanData = pasteData.replace(/[^a-zA-Z0-9]/g, '');
    if (!cleanData) return;
    const newOtp = [...otp];
    let j = startIndex;
    for (let i = 0; i < cleanData.length && j < 8; i++) {
      newOtp[j] = cleanData[i];
      j++;
    }
    setOtp(newOtp);
    const focusIndex = j < 8 ? j : 7;
    document.getElementById(`otp-${focusIndex}`).focus();
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const finalOtp = otp.join('');

    if (finalOtp.length < 8) {
      AlertService.error('OTP must be 8 characters.');
      return;
    }

    setLoading(true);
    try {
      const result = await UserService.ValidateMFAOTP({ otp: finalOtp }, authContext);
      if (result && result.isSuccess) {
        navigate("/configureqr/" + result.data);
      } else {
        AlertService.error(result.errorMessage || "Verification failed.");
      }
    } catch (ex) {
      console.error(ex);
      AlertService.error("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/profile');
  };

  return (
    <Fragment>
      <div className="d-flex profile container-fluid pt-3 mt-4">
        <div className="OtpVerify-left d-none d-xl-block">
          <img src={ProfileIcon} alt="Profile" />
        </div>
        <div className="profile-right d-flex flex-column justify-content-center mx-auto pt-5 mt-5 pt-xl-0 mt-xl-0" style={{ maxWidth: "600px" }}>
          {loading ? (
            <>
              <center>
                <Skeleton width="60%" height="3rem" className="mb-4" />
              </center>
              <div className="mb-4">
                <Skeleton width="100%" height="3rem" className="mb-2" />
                <Skeleton width="100%" height="3rem" />
              </div>
              <div className="d-flex justify-content-center mb-4 gap-3">
                {[...Array(6)].map((_, i) => (
                  <Skeleton key={i} width="3rem" height="3rem" className="rounded" />
                ))}
              </div>
              <div className="d-flex justify-content-between mt-5">
                <Skeleton width="30%" height="3.5rem" />
                <Skeleton width="30%" height="3.5rem" />
              </div>
            </>
          ) : (
            <>
              <h4 className="mb-4 text-center">OTP Verification</h4>
              <p className="mb-4 text-start">
                Please provide the One-Time Password sent to your email in the textbox below.
              </p>
              <Form onSubmit={handleSubmit}>
                <div className="d-flex justify-content-between mb-4 gap-2">
                  {otp.map((digit, i) => (
                    <input
                      key={i}
                      id={`otp-${i}`}
                      type="text"
                      maxLength="1"
                      className="form-control text-center otp-input custom-input-color"
                      value={digit}
                      onChange={(e) => handleOtpChange(e, i)}
                      onKeyDown={(e) => handleOtpKeyDown(e, i)}
                      onPaste={(e) => handlePaste(e, i)}
                      autoComplete="off"
                      disabled={loading}
                      autoFocus={i === 0} 
                    />
                  ))}
                </div>
                <div className="d-flex justify-content-between gap-2">
                  <button
                    type="button"
                    className="btn btn-outline py-2 mb-3 px-5"
                    onClick={handleCancel}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary mb-3 px-5 py-2"
                    disabled={loading}
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : null}
                    {loading ? 'Verifying...' : 'Verify'}
                  </button>
                </div>
              </Form>
            </>
          )}
        </div>
      </div>
    </Fragment>
  )
}

export default VerifyOtp;
